/**
 * Store URLs for app download badges.
 * `ComingSoonModal` is shown when a URL is empty.
 */
export const STORE_URLS = {
  playStore: 'https://play.google.com/store/apps/details?id=net.shmatch.app',
  appStore: 'https://apps.apple.com/gr/app/shmatch/id6777821734',
};

/** Ops: set before production deploy. */
export const CONTACT = {
  phoneDisplay: '+30 2102603719',
  phoneTel: '+302102603719',
  /** General contact (footer, vendors, legal general inquiries). */
  email: 'info@shmatch.net',
  /** GDPR / privacy / data-subject requests (legal policy, account deletion). */
  privacyEmail: 'shmatch.net@gmail.com',
};
